<template>
  <div class="search-lists-container" :class="customClass" :keywords="keywords">
    <NuxtLink
      class="search-result-item"
      v-for="(item, index) in searchItems"
      :key="index"
      :to="`/prod/m/${item.goodsSkuCode}`"
      @click="handleItemClick(item)"
    >
      <div class="search-item-left">
        <img
          class="search-item-logo"
          src="@/assets/image/accountOrder/logo.png"
          alt=""
        />
        <img @error="handleProductImageError"
          class="search-item-img"
          :src="item.mainImageUrl ? getProductImageUrl(item.mainImageUrl, 200) as string : defaultImage"
          alt=""
        />
      </div>
      <div class="search-item-right">
        <!-- <div class="search-item-code">{{ item.code }}</div>
        <div class="search-item-desc">{{ item.description }}</div> -->

        <div class="search-item-code">{{ item.oeNumber }}</div>
        <div class="search-item-desc">
          {{ item.backCategoryName + " / Replacement for:" }}
          <strong>{{ item.oeProducer }}</strong>

          {{ item.goodsApplication ? " / App: " + item.goodsApplication : "" }}
          <text class="goodsId">{{
            "&nbsp;&nbsp;[" + item.goodsSkuCode + "]"
          }}</text>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { getProductImageUrl, handleProductImageError } from '~/utils/productImageVariants';
import { defineProps, defineEmits, ref } from "vue";
import { search } from "~/api";
import defaultImage from "@/assets/image/default.png";

interface SearchItem {
  code: string;
  description: string;
  [key: string]: any;
}

const props = defineProps<{
  customClass?: string | string[];
  keywords?: string;
}>();

const pageinfo = ref({
  total: 0,
  size: 12,
  current: 1,
  pages: 0,
});

const searchItems = ref<SearchItem[]>([
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
  //   {
  //     code: "0001-218-174",
  //     description: "Starter / Replacement for: Bosch / App: IVECO [SB0048]",
  //   },
]);

const emit = defineEmits<{
  (e: "select", item: SearchItem): void;
}>();

const handleItemClick = (item: SearchItem) => {
  emit("select", item);
};

const formatOeProducer = (value: unknown) => {
  if (typeof value !== "string" || !value) {
    return "";
  }

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

const searchHandler = debounce(async (params) => {
  await search(params)
    .then((res: any) => {
      //   console.log(res);
      if (res.code == 200) {
        searchItems.value = res.result.records.map((item: any) => ({
          ...item,
          oeProducer: formatOeProducer(item.oeProducer),
        }));
      }
    })
    .catch((error) => {
      console.error(error);
    });
}, 500);

watch(
  () => props.keywords,
  (newValue) => {
    searchItems.value = [];
    if (!newValue?.trim()) {
      return;
    }
    if (newValue?.length >= 2) {
      let params = {
        searchStr: newValue,
        page: pageinfo.value.current,
        size: pageinfo.value.size,
      };
      searchHandler(params);
    }
  }
);
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.search-lists-container {
  width: 100%;
  background: #ffffff;
  box-shadow: 2px 2px 2px 1px rgba(7, 3, 4, 0.75);
  border-radius: 0 0 10px 10px;
  position: absolute;
  left: 0;
  top: 100%;
  padding: 6px 12px 7px 17px;
  // z-index: 100 !important;
  z-index: 3;
  border-radius: 0px 0px 22.55px 22.55px;

  &::-webkit-scrollbar {
    width: 8px;
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  .search-result-item {
    display: flex;
    padding: 6px 0 3px 5px;
    border-bottom: 1px solid #eeeeef;
    cursor: pointer;
    align-items: center;
    color: inherit;
    text-decoration: none;

    // &:hover {
    //     background-color: #f5f5f5;
    // }

    &:last-child {
      border-bottom: none;
    }

    .search-item-left {
      // width: 70px;
      // height: 50px;
      // position: relative;
      display: flex;
      flex-direction: column;
      gap: 1px;
      margin-right: 15px;

      .search-item-img {
        width: 62px;
        height: 24px;
        object-fit: cover;
      }

      .search-item-logo {
        width: 12px;
        height: 10px;
        margin-left: 3px;
        object-fit: cover;
      }
    }

    .search-item-right {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 31px;

      .search-item-code {
        min-width: 4vw;
        font-family: Galvji-Bold, Galvji-Bold;
        font-size: 14px;
        color: #1b1311;
        line-height: 22px;
      }

      .search-item-desc {
        font-family: Galvji, Galvji;
        font-size: 12px;
        color: #5e5d5e;
        line-height: 22px;
      }
    }
  }
}
.goodsId {
  color: #c51e1e;
}
</style>
